// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__33aEC","filesListContainer":"PosDisputesFiles_filesListContainer__1QePS","filesButton":"PosDisputesFiles_filesButton__3iwKQ"};